<div class="d-flex flex-row py-8">
  <div class="d-lg-flex flex-column flex-lg-row-auto w-lg-325px" [class.drawer-on]="navOpen()" data-kt-drawer="true"
    data-kt-drawer-name="start-sidebar" data-kt-drawer-activate="{default: true, lg: false}"
    data-kt-drawer-overlay="true" data-kt-drawer-width="{default:'200px', '250px': '300px'}"
    data-kt-drawer-direction="start" data-kt-drawer-toggle="#kt_social_start_sidebar_toggle">
    <div class="card h-100 h-lg-unset">
      <div class="card-body pt-8 px-0">
        @if (userObserve | async; as _user) {
        <div class="d-flex flex-column text-center align-items-center mb-9 px-8">
          <div class="symbol symbol-circle symbol-80px symbol-lg-150px mb-4">
            <!-- `_user.data.image_url` is the raw, relative path from
                 `/users/current` — `UserModel.setUser` (which would have made
                 it absolute) is never actually called anywhere in this app,
                 so it still needs `fileUrl` here. No `blank.png` though: a
                 person icon instead, like every other avatar placeholder on
                 the site. -->
            @if (_user.data.image_url) {
            <img [src]="fileUrl + _user.data.image_url" class="object-fit-cover" [alt]="_user.data.full_name" />
            } @else {
            <span class="symbol-label bg-light-primary text-primary">
              <app-keenicon name="user" class="fs-3x fs-lg-5x text-primary"></app-keenicon>
            </span>
            }
          </div>

          <div class="text-center">
            <a class="text-gray-800 fw-bold fs-4">{{ _user.data.full_name }}</a>
            <a class="d-block text-muted fw-bold fs-7 mb-1">{{
              _user.email
              }}</a>

            <span class="text-muted d-block fw-semibold">
              @if(_user.role.id === 2){
              {{ Role.MEMBER }}
              }@else {
              {{ Role.PARENT }}

              }
            </span>
          </div>
        </div>


        <div class="m-0">
          <ul class="nav nav-pills nav-pills-custom flex-column border-transparent fs-5 fw-semibold">
            <li class="d-lg-none nav-item mt-5">
              <a class="nav-link text-muted text-active-primary ms-0 py-0 me-10 ps-9 border-0" routerLink="/about-us"
                routerLinkActive="active">
                <div class="d-flex flex-row align-items-center gap-3">
                  <app-keenicon name="information" class="fs-1 svg svg-icon"></app-keenicon>

                  <span>{{ "MENU.ABOUT_US" | translate }}</span>
                </div>

                <span class="bullet-custom position-absolute start-0 top-0 w-3px h-100 bg-primary rounded-end"></span>
              </a>
            </li>
            <li class="d-lg-none nav-item mt-5">
              <a class="nav-link text-muted text-active-primary ms-0 py-0 me-10 ps-9 border-0" routerLink="/courses"
                routerLinkActive="active">
                <div class="d-flex flex-row align-items-center gap-3">
                  <app-keenicon name="note" class="fs-1 svg svg-icon"></app-keenicon>

                  <span>{{ "MENU.COURSES" | translate }}</span>
                </div>

                <span class="bullet-custom position-absolute start-0 top-0 w-3px h-100 bg-primary rounded-end"></span>
              </a>
            </li>
            <li *ngxPermissionsOnly="[Permission.ENTER_COURSE]" class="d-lg-none nav-item mt-5">
              <a class="nav-link text-muted text-active-primary ms-0 py-0 me-10 ps-9 border-0"
                routerLink="/online-class" routerLinkActive="active">
                <div class="d-flex flex-row align-items-center gap-3">
                  <app-keenicon name="screen" class="fs-1 svg svg-icon"></app-keenicon>

                  <span>
                    {{ "MENU.ONLINE_CLASS" | translate }}
                  </span>
                </div>

                <span class="bullet-custom position-absolute start-0 top-0 w-3px h-100 bg-primary rounded-end"></span>
              </a>
            </li>

            <div class="d-lg-none px-10">
              <div class="separator mt-6 mb-0"></div>
            </div>
            <li class="nav-item mt-5">
              <a class="nav-link text-muted text-active-primary ms-0 py-0 me-10 ps-9 border-0 active"
                routerLink="/profile/monitor" routerLinkActive="active">
                <div class="d-flex flex-row align-items-center gap-3">
                  <app-keenicon name="chart-line-star" class="fs-1 svg svg-icon"></app-keenicon>

                  <span>
                    {{ "MENU.MONITOR" | translate }}
                  </span>
                </div>
                <span class="bullet-custom position-absolute start-0 top-0 w-3px h-100 bg-primary rounded-end"></span>
              </a>
            </li>
            <li class="nav-item mt-5">
              <a class="nav-link text-muted text-active-primary ms-0 py-0 me-10 ps-9 border-0"
                routerLink="/profile/account" routerLinkActive="active">
                <div class="d-flex flex-row align-items-center gap-3">
                  <app-keenicon name="user-square" class="fs-1 svg svg-icon"></app-keenicon>

                  <span>
                    {{ "MENU.PROFILE" | translate }}
                  </span>
                </div>

                <span class="bullet-custom position-absolute start-0 top-0 w-3px h-100 bg-primary rounded-end"></span>
              </a>
            </li>
            <li class="nav-item mt-5">
              <a class="nav-link text-muted text-active-primary ms-0 py-0 me-10 ps-9 border-0"
                routerLink="/profile/password" routerLinkActive="active">
                <div class="d-flex flex-row align-items-center gap-3">
                  <app-keenicon name="key" class="fs-1 svg svg-icon"></app-keenicon>

                  <span>
                    {{ "AUTH.PASSWORD" | translate }}
                  </span>
                </div>

                <span class="bullet-custom position-absolute start-0 top-0 w-3px h-100 bg-primary rounded-end"></span>
              </a>
            </li>
            <li *ngxPermissionsOnly="[Permission.ASSIGN_COURSE]" class="nav-item mt-5">
              <a class="nav-link text-muted text-active-primary ms-0 py-0 me-10 ps-9 border-0"
                routerLink="/profile/parent-courses" routerLinkActive="active">
                <div class="d-flex flex-row align-items-center gap-3">
                  <app-keenicon name="book" class="fs-1 svg svg-icon"></app-keenicon>

                  <span>
                    {{ "MENU.PARENT_COURSE" | translate }}
                  </span>
                </div>

                <span class="bullet-custom position-absolute start-0 top-0 w-3px h-100 bg-primary rounded-end"></span>
              </a>
            </li>
            <li class="nav-item mt-5">
              <a class="nav-link text-muted text-active-primary ms-0 py-0 me-10 ps-9 border-0"
                [routerLink]="_user.role.id === 2? `/profile/parent`:`/profile/student`" routerLinkActive="active">
                <div class="d-flex flex-row align-items-center gap-3">
                  <app-keenicon name="people" class="fs-1 svg svg-icon"></app-keenicon>

                  <span>
                    {{ "MENU.PARENT_MENU" | translate }}
                  </span>
                </div>

                <span class="bullet-custom position-absolute start-0 top-0 w-3px h-100 bg-primary rounded-end"></span>
              </a>
            </li>
          </ul>
        </div>
        }

      </div>
    </div>
  </div>

  <!-- -------------------------------------------------------- -->

  <!--begin::Content-->
  <div class="w-100 flex-lg-row-fluid ps-lg-8">
    <!-- The handle for the sidebar drawer.
         Below lg the account navigation is a Metronic drawer
         (`data-kt-drawer-toggle="#kt_social_start_sidebar_toggle"`) and that id
         existed nowhere in the app — so on a phone the drawer had no handle and
         "password", "parent menu" and the study records were unreachable from
         the account screen entirely. -->
    <button id="kt_social_start_sidebar_toggle" type="button"
      class="btn btn-light-primary d-flex d-lg-none align-items-center gap-2 mb-5" [attr.aria-expanded]="navOpen()"
      (click)="navOpen.set(!navOpen())">
      <app-keenicon name="burger-menu-2" class="fs-3 svg svg-icon"></app-keenicon>
      {{ "APP.PROFILE_MENU" | translate }}
    </button>
    <!-- Sized against the sidebar beside it, not against the window.
         `min-h-70` is 70vh, so this card was 630px tall on a 900px screen no
         matter what was in it — the parent screen left 263px of empty white
         below its content and the password screen 121px. The row already
         stretches its columns, so h-100 makes the card match the sidebar, and
         the floor is only there to stop a nearly-empty screen collapsing. -->
    <div class="card card-flush h-100 min-h-350px">
      <router-outlet></router-outlet>
    </div>
  </div>
  <!--end::Content-->

  <!-- The drawer's own backdrop. Metronic paints one from its JS, which only
       runs for drawers it wired up itself; this one is driven from the
       component so the panel cannot be left open with no way out. -->
  @if (navOpen()) {
  <div class="profile-nav-backdrop d-lg-none" (click)="navOpen.set(false)"></div>
  }
</div>